import { Component, OnInit, HostListener, ElementRef, AfterViewInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { UserService } from '../services/user.service';
import { HttpErrorResponse } from '@angular/common/http';

declare var bootstrap: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, AfterViewInit {
  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      let bsCollapse = bootstrap.Collapse.getInstance(document.getElementById('sidebar'));
      if (bsCollapse) {
        bsCollapse.hide();
      }
    }
  }

  environment = environment;

  constructor(public userService: UserService, private router: Router, private eRef: ElementRef) { }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    let bsCollapse = new bootstrap.Collapse(document.getElementById('sidebar'), {
      toggle: false
    });

    if (bsCollapse) {
      document.getElementById('sidebar')!.addEventListener('show.bs.collapse', function () {
        $('#menu-backdrop').fadeIn("slow");
      });
      document.getElementById('sidebar')!.addEventListener('hide.bs.collapse', function () {
        $('#menu-backdrop').fadeOut("slow");
      });
    }
  }

  public isActive(urls: Array<string>): boolean {
    for (let i = 0; i < urls.length; i = i + 1) {
      if (this.router.url.includes(urls[i])) {
        return true;
      }
    }
    return false;
  }

  logout() {
    Swal.fire({
      title: 'Sair do sistema?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sair',
      cancelButtonText: 'Cancelar',
      heightAuto: false,
      allowOutsideClick: false,
      focusConfirm: false,
      customClass: {
        confirmButton: 'btn-swal',
        cancelButton: 'btn-swal-cancel'
      },
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return new Promise((resolve, reject) => {
          (this.userService.logout().subscribe(
            (res) => {
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              resolve('');
            },
            (err) => {
              if (err instanceof HttpErrorResponse) {
                if (err.status === 401) {
                  localStorage.removeItem('botway');
                  this.router.navigate(['/login']);
                  resolve('');
                }
              }
            }
          ))
        });
      }
    });
  }
}
